<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>产品来源</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" >
                <span class="label-span">
                    <label class="label">手机号码</label> 
                    <el-input v-model.trim="query.phone" placeholder="来源名称" class="handle-input mr10"></el-input> 
                </span>   
                <span class="label-span">
                    <label class="label">归属省份</label> 
                    <el-input v-model.trim="query.province" placeholder="归属省份" class="handle-input mr10"></el-input> 
                </span>   
                <span class="label-span">
                    <label class="label">归属市区</label> 
                    <el-input v-model.trim="query.city" placeholder="归属市区" class="handle-input mr10"></el-input> 
                </span>   
                <span class="label-span">
                    <label class="label">运营商</label> 
                    <el-select v-model.trim="query.isp" placeholder="请选择" class="handle-input mr10"  > 
                        <el-option label="移动" value="1" />
                        <el-option label="联通" value="2" />
                        <el-option label="电信" value="3" />    
                    </el-select>  
                </span>   
                <el-button type="success" icon="el-icon-search" class="mr10" @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr10" @click="refreshSearch">重置</el-button> 
                <el-button  type="primary"  icon="el-icon-download" class="mr10" @click="modelDown" >模板下载</el-button> 
                <el-button  type="primary" icon="el-icon-upload" class="mr10"  @click="addExcel" >数据导入</el-button> 
               
               
          </el-card>
          <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>--> 
                <el-table-column prop="phone" min-width="110" align="left" label="手机号码"> </el-table-column>
                <el-table-column prop="isp" width="80" align="center" label="运营商">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.isp==1?'primary':scope.row.isp==2?'danger':scope.row.isp==3?'info':'info'">{{scope.row.isp==1?'移动':scope.row.isp==2?'联通':scope.row.isp==3?'电信':'其它'}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="province" min-width="110" align="left" label="归属省份"> </el-table-column>     
                <el-table-column prop="city" min-width="110" align="left" label="归属市区"> </el-table-column>        
                <el-table-column label="操作" min-width="110" align="center"  fixed="right">
                    <template slot-scope="scope"> 
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>
                  
            </el-table>
            <div class="pagination">
                <el-pagination 
                   background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </el-card> 
        <!-- 新建自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="数据导入" :visible.sync="addVisible" :modal-append-to-body='false' top="80px" width="410px">
            <el-upload :fileList="fileList" action="#" drag :file-list="fileList" :on-remove="handleRemove" :auto-upload="false" :limit="1" :on-change="handleChange" :on-exceed="handleExceed"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或点击上传</div>
                    <div class="el-upload__tip" slot="tip">只能上传xls、xlsx文件，且大小不超过5M</div>
                    </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
         
  

        <!-- 编辑自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑号段" :visible.sync="editVisible" :modal-append-to-body='false' top="50px" width="530px">
            <el-form ref="form3" :model="form3" label-width="120px">
                <el-form-item label="号码前三位">
                    <el-input v-model.trim="form2.phone3"  placeholder="号码前三位" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="号码前七位">
                    <el-input v-model.trim="form2.phone4"  placeholder="号码前七位" style="width:360px;"></el-input>
                </el-form-item>   
                <el-form-item label="运营商">
                   <el-radio-group  v-model.trim="form2.isp" >
                        <el-radio-button label="1">移动</el-radio-button> 
                        <el-radio-button label="2">联通</el-radio-button>
                        <el-radio-button label="3">电信</el-radio-button> 
                    </el-radio-group> 
                </el-form-item>   
                <el-form-item label="归属省份">
                    <el-input v-model.trim="form2.province"  placeholder="归属省份" style="width:360px;"></el-input>
                </el-form-item>   
                <el-form-item label="归属市区">
                    <el-input v-model.trim="form2.city"  placeholder="归属市区" style="width:360px;"></el-input>
                </el-form-item>     
                <el-form-item label="行政编码">
                    <el-input v-model.trim="form2.code"  placeholder="行政编码" style="width:360px;"></el-input>
                </el-form-item>     
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
          
    </div>
</template>

<script>
import {fetchDataAll as fetchData,saveForm,handDelete,changeForm,changeStatus,uploadExcel} from './comStateTd';
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            fileList:[],
            activeNames:1,
            select:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                ctype:'2',  
            },
            form2: {   },
            form3: {   },
            form4: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();  
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'phone', '');  
            this.$set(this.query, 'province');    
            this.$set(this.query, 'city');    
            this.$set(this.query, 'isp');    
            this.getData();
        }, 
        modelDown(){
            const url = window.location.protocol + '//' + localStorage.getItem(window.location.hostname + '_stationUrl') +"/comState/downModel.do?state=3";   
            window.open(url); 
        },
        addExcel(){
            this.addVisible = true; 
        },
        handleRemove(file, fileList) {
            this.fileList = []; 
        }, 
        handleExceed(files, fileList) {
            this.$message.warning(`每次只能上传一个文件`);
        },
        //详情图上传成功追加数据 
        handleChange(file,fileList) { 
            file.name.split(".")[1] === "xls"
            const isJPG =file.raw.type === "image/jpeg" || file.raw.type === "image/png" || file.raw.type === "image/gif" || file.raw.type === "image/jpg";
            const isMax = file.size / 1024 / 1024  < 5;
            if (file.name.split(".")[1] != "xls" && file.name.split(".")[1] != "xlsx") {
                this.$message.error("上传文件片只能是 xls、xlsx 格式!");
                fileList.splice(-1, 1);//移除错误文件
                return false;
            }
            if (!isMax) {
                this.$message.error("导入文件大小不能超过 5MB!");
                fileList.splice(-1, 1);
                return false;
            }  
            this.fileList = fileList;	  
            
        }, 

        //触发刷新按钮
        refresh(){
            history.go(0);
            
        }, 

        //查询
        getData(){ 
            this.query.type = '3';   
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        

        // 新增渠道
        addBind() {
            this.addVisible = true; 
        },
        //保存新增
        saveForm() {   
             if(this.fileList.length==0){
                this.$message.error("请上传excel文件"); 
                return;
            } 
            let formData = new FormData();   
            formData.append("file",this.fileList[0].raw,this.fileList[0].name); 
            formData.append("type",'3'); 
            this.loading = true;
            this.addVisible = false;
            uploadExcel(formData).then(res => { 
                this.loading = false;
                if(res.code=='200'){
                    this.fileList = [];  
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.editPlusVisible = true;
                    this.$message.error(res.message); 
                }
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {      
            this.editVisible = true;
            this.form2 = row; 
        },
 
        
        // 保存更改
        saveEdit() {   
            changeForm(this.form2).then(res => {
                if(res.code=='200'){
                    this.editVisible = false; 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ;
            var content;
            if(row.status=='0'){ 
                tips = "禁用";
                content = "确定禁用吗？";
            }else{ 
                tips = "启用";
                content = "确定启用吗？"; 
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
           
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid; 
            // 二次确认删除
            this.$confirm('确认删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
